(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {

 // Slide down animation for dropdowns in offcanvas nav menu
 document.querySelectorAll('.nav-item[data-bs-toggle="dropdown"]').forEach(toggle => {
   // Get the next sibling which should be the .subnav.dropdown-menu
   const dropdownMenu = toggle.parentElement.querySelector('.subnav.dropdown-menu');

   // Prevent default bootstrap dropdown behavior
   toggle.addEventListener('click', (e) => {
     e.preventDefault();
     
     // Close other open dropdowns
     document.querySelectorAll('.subnav.dropdown-menu.open').forEach(menu => {
       if (menu !== dropdownMenu) {
         menu.classList.remove('open');
       }
     });

     // Toggle open class for slide animation
     dropdownMenu.classList.toggle('open');
   });

   // Close dropdown if clicking outside
   document.addEventListener('click', (event) => {
     if (!toggle.contains(event.target) && !dropdownMenu.contains(event.target)) {
       dropdownMenu.classList.remove('open');
     }
   });
 });

  let searchTrigger = document.getElementById('navbar-search-trigger');
  let searchBar = document.getElementById('navbar-search-bar');
  let searchInput = searchBar ? searchBar.querySelector('input[name="q"]') : null;
  let wrapper = document.getElementById('predictiveSearchResultsWrapper');

  // close search when clicking outside
  document.body.addEventListener('click', (event) => {
    if (event.target.parentElement == (searchTrigger) || searchBar.contains(event.target)) {
      // do nothing
    } else {
      searchBar.classList.add('d-none');
      searchInput.value = '';
      wrapper.innerHTML = '';
    }
  });
 
  if (searchTrigger && searchBar) {
    searchTrigger.addEventListener('click', function(e) {
      if (searchBar.classList.contains('d-none')) {
        searchBar.classList.remove('d-none');
        searchInput?.focus();
      } else {
        searchBar.classList.add('d-none');
        searchInput.value = '';
        wrapper.innerHTML = '';
      }
    });
  }

  // Some key commands for search
  document.addEventListener('keydown', function(e) {
    if (e.key === "Escape") {
      searchBar.classList.add('d-none');
    }
  });

});
  } catch(e) { console.error(e); }
})();

})();
